import React, { useState, useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";
import "./App.scss";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Form from "./pages/Form";

const App = () => {
  const { t, i18n } = useTranslation();
  const queryParameters = new URLSearchParams(window.location.search);
  document.title = i18n.language == "hk" ?t("global:title"): `"Guess The Numbers of SSS Panda's" Prize Game`;

  useEffect(() => {
    queryParameters.get("lang")
      ? i18n.changeLanguage(queryParameters.get("lang"))
      : i18n.changeLanguage("hk");
  }, []);

  return (
    <div>
      <Header />
      <Form />
      <Footer />
    </div>
  );
};

export default App;
